import { SpaceCard, MultiViewSlider } from "reusableComponents";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import SpaceCardStyled from "reusableComponents/SpaceCardStyled";

const LandingPageSlider = ({
  spaces,
  largeBreakpoint = 1200,
  themeColor = null,
  forMemberPlus = false,
  externalId = null,
  slidesNum = 3,
}) => {
  const [t, i18n] = useTranslation("global");

  const spacesRenderer = spaces.map((space) => (
    <div className={styles.landingPageSpaceCardContainer} key={space.id}>
      <SpaceCardStyled
      borderColor="primary"
        place={space}
        onHover={() => {}}
        onLeave={() => {}}
        externalId={externalId}
        themeColor={themeColor}
        forMemberPlus={forMemberPlus}
      />
    </div>
  ));

  return (
    <section>
      <div className={styles.landingPageSliderWrapper}>
        <MultiViewSlider
        arrowStyle="square"
        slidesNum={slidesNum}
          key={`992-${spaces.length}`}
          arrowLeft="-44px"
          arrowRight="-44px"
          responsive={[
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 2,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 2,
              },
            },
            {
              breakpoint: largeBreakpoint,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 2,
              },
            },
          ]}
        >
          {spacesRenderer}
        </MultiViewSlider>
      </div>
    </section>
  );
};

export default LandingPageSlider;
